import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faReceipt } from '@fortawesome/free-solid-svg-icons'
import Header from '../Header/Header'
import VentasData from '../../Components/Admin/VentasData/VentasData'
import GastosData from '../../Components/Admin/GastosData/GastosData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import './Ventas.css'

export default function Ventas() {
    const [vista, setVista] = useState('ventas'); // 'ventas' | 'gastos'

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <div className="ventas-tabs">
                        <button
                            className={`ventas-tab${vista === 'ventas' ? ' active' : ''}`}
                            onClick={() => setVista('ventas')}
                        >
                            <FontAwesomeIcon icon={faHandHoldingDollar} /> Ventas
                        </button>
                        <button
                            className={`ventas-tab${vista === 'gastos' ? ' active' : ''}`}
                            onClick={() => setVista('gastos')}
                        >
                            <FontAwesomeIcon icon={faReceipt} /> Gastos
                        </button>
                    </div>

                    {vista === 'ventas' ? <VentasData /> : <GastosData />}
                </div>
            </section>
        </div>
    )
}
